import type {ComponentProps} from "react";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {AnankeAvatar} from "@vesta/ananke/components/anankeAvatar";
import {useWorkspaceProfilePictureSrc} from "~/hooks/useWorkspaceProfilePictureSrc";
import {parseProfilePictureStoredValue} from "~/utilities/profilePictureReference";

function WorkspaceUserAnankeAvatarForAsset(props: {
    assetId: Uuid;
    rest: Omit<ComponentProps<typeof AnankeAvatar>, "src">;
}) {
    const {resolvedSrc} = useWorkspaceProfilePictureSrc(props.assetId);
    return <AnankeAvatar {...props.rest} src={resolvedSrc} />;
}

export function WorkspaceUserAnankeAvatar(props: ComponentProps<typeof AnankeAvatar>) {
    const {src, ...rest} = props;
    if (src === undefined || src === "" || src === null) {
        return <AnankeAvatar {...props} />;
    }
    if (src.startsWith("blob:") === true) {
        return <AnankeAvatar {...props} />;
    }
    const parsed = parseProfilePictureStoredValue(src);
    if (parsed.kind === "legacyUrl") {
        return <AnankeAvatar {...props} />;
    }
    if (parsed.kind === "none") {
        return <AnankeAvatar {...rest} src={undefined} />;
    }
    return <WorkspaceUserAnankeAvatarForAsset assetId={parsed.assetId} rest={rest} />;
}
